import common from './common'

// window.IS_LANG_TRANSLATE_SCRIPT_LOADED = false
// window.isTranslationScriptCodeLoaded = false

export default function setUpGoogleTranslate(targetElement) {
  // **Clear previous Google Translate instances**
  function resetGoogleTranslate() {
    document.querySelectorAll('.goog-te-banner-frame, .goog-te-gadget').forEach(el => el.remove())

    // Remove the script tag to force reloading
    const existingScript = document.querySelector('script[src*="translate.google.com"]')
    if (existingScript) {
      existingScript.remove()
    }

    // Remove previous translate container
    const translateContainer = document.getElementById(targetElement)
    if (translateContainer) {
      translateContainer.innerHTML = ''
    }
  }

  window.googleTranslateElementInit = () => {
    if (window.isTranslationScriptCodeLoaded) return
    window.isTranslationScriptCodeLoaded = true

    // Get locale from storage and map it to Google's language codes
    const locale = localStorage.getItem('locale') || 'en'
    const localeMap = {
      en: 'en',
      vn: 'vi',
      jp: 'ja',
      kr: 'ko',
      tw: 'zh-TW', // Chinese Traditional
      tr: 'tr',
      my: 'ms',
    }
    const localeLang = localeMap[locale] || locale

    // const langBrowser = navigator.language || navigator.userLanguage
    // const currentBLang = localeLang || langBrowser.split('-')[0]

    // **Ensure targetElement exists before initializing**
    const translateContainer = document.getElementById(targetElement)
    if (!translateContainer) {
      console.error(`Google Translate target element "${targetElement}" not found.`)
      return
    }
    // **Initialize Google Translate widget again**
    // eslint-disable-next-line no-new, no-undef
    new google.translate.TranslateElement(
      {
        pageLanguage: 'en',
        includedLanguages: 'en,ja,ko,vi,ne,zh-TW,tr,ms,ru,ar',
      },
      targetElement,
    )
    setTimeout(() => {
      const selectElement = document.querySelector(`#${targetElement} select`)
      if (selectElement) {
        selectElement.value = localeLang
        selectElement.dispatchEvent(new Event('change'))
      }
    }, 1600)
  }

  // **Remove previous instances and reload Google Translate**
  resetGoogleTranslate()

  if (!window.IS_LANG_TRANSLATE_SCRIPT_LOADED) {
    common.loadExternalCdn('//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit')
    window.IS_LANG_TRANSLATE_SCRIPT_LOADED = true
  } else {
    window.isTranslationScriptCodeLoaded = false
    window.googleTranslateElementInit()
  }

  // **Fix styling issues**
  const styleId = 'google-translate-style'
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style')
    style.id = styleId
    style.textContent = `
      .skiptranslate:not(.goog-te-gadget) { display: none !important; } 
      body { top: 0 !important } 
      .skiptranslate.goog-te-gadget { visibility: hidden !important; } 
      .skiptranslate.goog-te-gadget div { visibility: visible; }
      select.goog-te-combo { padding: 4px; }
      .VIpgJd-ZVi9od-aZ2wEe-wOHMyf { display: none; }
    `
    document.head.appendChild(style)
  }
}
